import { useThemeSetting } from '@tamagui/next-theme';
import { useEffect, useState } from 'react';
import { Platform, useColorScheme } from 'react-native';
import Svg, { G, Path } from 'react-native-svg';

export function KisanLogoNew({ width, height }) {
  const colorScheme = useColorScheme();
  const themeSetting = useThemeSetting();
  const ninjaColor =
    colorScheme === 'dark'
      ? Platform.OS === 'web'
        ? '#ffffff' // web dark
        : '#ffffff' // mobile dark
      : '#000000'; // light mode

  const [iconColor, setIconColor] = useState('#1D130A'); 
  
  useEffect(() => {
    setIconColor(ninjaColor);
  }, [themeSetting]);

  return (
    <>
      <Svg
        width={width}
        height={height}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1432.5 410.1"
      >
        <Path
          fill={iconColor}
          d="M479.4,199.6v70h-22v-67.5c0-23.9-11.9-35.6-32.8-35.6s-38.6,14-38.6,40.4v62.7h-22v-121.7h21.1v18.4c9-12.4,24.6-19.5,43.9-19.5,29.6,0,50.5,17,50.5,52.8h0Z"
        />
        <Path
          fill={iconColor}
          d="M492.5,110.3c0-8,6.4-14.5,14.9-14.5s14.9,6.2,14.9,14-6.2,14.7-14.9,14.7-14.9-6.2-14.9-14.2h0ZM496.4,147.9h22v121.7h-22v-121.7Z"
        />
        <Path
          fill={iconColor}
          d="M652.1,199.6v70h-22v-67.5c0-23.9-11.9-35.6-32.8-35.6s-38.6,14-38.6,40.4v62.7h-22v-121.7h21.1v18.4c9-12.4,24.6-19.5,43.9-19.5,29.6,0,50.5,17,50.5,52.8h0Z"
        />
        <Path
          fill={iconColor}
          d="M628.4,308.2l7.1-17c4.4,3.7,10.8,5.7,17.9,5.7,11.7,0,18.1-7.4,18.1-21.4v-127.7h22v127.2c0,24.8-13.8,40.4-38.8,40.4s-20.2-2.3-26.4-7.4ZM667.7,110.3c0-8,6.4-14.5,14.9-14.5s14.9,6.2,14.9,14-6.2,14.7-14.9,14.7-14.9-6.2-14.9-14.2h0Z"
        />
        <Path
          fill={iconColor}
          d="M816.2,196.1v73.5h-20.9v-16.1c-7.3,11-20.9,17.5-40,17.5-27.5,0-45-14.7-45-35.8s12.6-35.6,48.9-35.6h34.9v-4.4c0-18.6-10.8-29.4-32.6-29.4s-29.2,5.1-38.6,13.1l-9.2-16.5c12.6-10.1,30.8-15.6,50.3-15.6,33.3,0,52.1,16.1,52.1,49.4h0ZM794.1,232.4v-17h-34c-21.8,0-28,8.5-28,18.8s10.1,19.8,26.9,19.8,29.6-7.6,35.1-21.6h0Z"
        />
        <Path
          fill="#e7077f"
          d="M881.5,221.5l-21.5,19.9v28.4h-18.8V124.7h18.8v93.1l56.5-51.6h22.7l-43.6,42.8,47.9,60.8h-23.1l-38.9-48.3h0Z"
        />
        <Path
          fill="#e7077f"
          d="M946,134.1c0-6.8,5.5-12.3,12.7-12.3s12.7,5.3,12.7,11.9-5.3,12.5-12.7,12.5-12.7-5.3-12.7-12.1ZM949.3,166.2h18.8v103.7h-18.8v-103.7h0Z"
        />
        <Path
          fill="#e7077f"
          d="M980.8,258.9l7.8-14.9c8.8,6.3,22.9,10.8,36.4,10.8s24.7-5.3,24.7-14.1c0-23.3-65.5-3.1-65.5-44.4s16.6-31.1,43.2-31.1,28.8,3.5,37.8,9.4l-8,14.9c-9.4-6.1-19.8-8.2-29.9-8.2-16.4,0-24.5,6.1-24.5,14.3,0,24.4,65.7,4.5,65.7,44.8s-17.2,30.7-44.8,30.7-34.2-5.3-42.8-12.1h0Z"
        />
        <Path
          fill="#e7077f"
          d="M1167.1,207.2v62.6h-17.8v-13.7c-6.3,9.4-17.8,14.9-34,14.9-23.5,0-38.3-12.5-38.3-30.5s10.8-30.3,41.7-30.3h29.7v-3.7c0-15.8-9.2-25-27.8-25s-24.8,4.3-32.9,11.1l-7.8-14.1c10.8-8.6,26.2-13.3,42.8-13.3,28.4,0,44.4,13.7,44.4,42.1h0ZM1148.3,238.1v-14.5h-28.9c-18.6,0-23.9,7.2-23.9,16s8.6,16.8,22.9,16.8,25.2-6.4,29.9-18.4h0Z"
        />
        <Path
          fill="#e7077f"
          d="M1282.2,210.2v59.7h-18.8v-57.5c0-20.3-10.2-30.3-28-30.3s-32.9,11.9-32.9,34.4v53.4h-18.8v-103.7h18v15.6c7.6-10.6,20.9-16.6,37.4-16.6,25.2,0,43,14.5,43,45h0Z"
        />
        <G>
          <G>
            <Path
              fill="#2d3c96"
              d="M101.4,131c-4.3-4.3-4.9-10.8-1.9-15.7-23.9,25-36.7,57.6-36.2,92.3.5,34,14,66.1,38.2,90.4.7.8,1.5,1.5,2.2,2.2,4.9,3.1,11.6,2.5,15.9-1.8,4.3-4.3,4.9-11,1.7-16-.7-.7-1.4-1.4-2.1-2.1-19.6-19.7-30.5-45.6-30.9-73.1-.4-28,10-54.3,29.2-74.5-5,3.3-11.7,2.7-16.1-1.7h0Z"
            />
            <Path
              fill="#e50c7f"
              d="M119.6,298.3c-4.3,4.3-10.9,4.9-15.9,1.8,23.9,22.9,55,35.8,87.9,36.4.8,0,1.6,0,2.5,0,21.6,0,43-5.4,61.9-15.5,2.9-1.6,5.1-4.2,6-7.4s.6-6.6-1-9.5-4.2-5.1-7.4-6c-3.2-1-6.6-.6-9.5,1-15.9,8.5-33.9,12.8-52.1,12.5-26.5-.5-51.5-10.9-70.8-29.2,3.2,5,2.6,11.6-1.7,16h0Z"
            />
            <Path
              fill="#f89a21"
              d="M268.8,113c4.3-4.3,11-4.9,15.9-1.8-23.5-22.6-55.4-36.4-90.5-36.4s-68.4,13.8-93.2,39c-.5.5-1,1-1.4,1.5-3,4.9-2.4,11.5,1.9,15.7,4.4,4.4,11.1,4.9,16.1,1.7.4-.4.9-.9,1.3-1.4,20.1-20.3,46.8-31.5,75.4-31.5s53.8,11.1,72.8,29.1c-3.1-4.9-2.5-11.6,1.8-15.9h0Z"
            />
            <Path
              fill="#2ab24b"
              d="M284.7,111.2c-5-3.1-11.6-2.6-15.9,1.8-4.3,4.3-4.9,10.9-1.8,15.9,20.4,19.3,33.1,46.6,33.1,76.8s-24.3,54-46,54-18.8-3.6-26.8-11.4c-3.1-3-6-6.7-8.6-10.9l-55.8-89.9c-2.9-4.7-8.7-6.9-14.1-5.4s-9.1,6.5-9.1,12v118.2c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5v-74.3l32.6,52.6c3.7,6,7.9,11.2,12.5,15.7,12.8,12.4,27.3,18.4,44.2,18.4s37.5-9,51.2-25.3c12.6-15,19.8-34.6,19.8-53.7,0-37.1-15.5-70.6-40.4-94.5h0Z"
            />
          </G>
          <G>
            <Path
              fill="#007c3f"
              d="M251.3,185.9c0-1.4.1-2.9.1-4.3,0-6.3-.9-12.5-2.6-18.2l-11.3,11.3v25.1l13.8-13.8Z"
            />
            <Path fill="#007c3f" d="M235.4,141.7c-4.6,5.7-8.2,12.3-10.6,19.4l10.6,10.6v-29.9Z" />
            <Path fill="#007c3f" d="M237.5,141.7v29.9l10.6-10.6c-2.4-7.1-6-13.6-10.6-19.4Z" />
            <Path fill="#007c3f" d="M237.5,202.7v18.8c7.2-9.1,12.1-20.2,13.5-32.3l-13.5,13.5Z" />
            <Path
              fill="#007c3f"
              d="M235.4,199.7v-25.1l-11.3-11.3c-1.7,5.8-2.6,11.9-2.6,18.2s0,2.9.1,4.3l13.8,13.8Z"
            />
            <Path fill="#007c3f" d="M221.9,189.2c1.4,12.1,6.3,23.2,13.5,32.3v-18.8l-13.5-13.5Z" />
          </G>
        </G>
      </Svg>
    </>
  );
}
